export default function TripCheckoutTermsController(
    userService,
    tripDetails,
    tripCheckoutModel,
    tripFactory,
    tripDetailsService
) {
    'ngInject';
    const vm = this;

    Object.assign(vm, {
        isLinkToVisaDatabaseVisible,
        isBillbackTermsAndConditionsVisible,
        isTermsBlockVisible,
        isDbahnConditionVisible,
    });

    function isLinkToVisaDatabaseVisible() {
        return !userService.isBERegion();
    }

    function isBillbackTermsAndConditionsVisible() {
        return tripDetailsService.doesTripContainBillbackRoom(tripDetails)
            && tripDetailsService.isTripPaymentTypeInvoice(tripCheckoutModel);
    }

    function isTermsBlockVisible(tripData) {
        return tripData.TermsAndConditionsConfiguration !== null && tripData.TermsAndConditionsConfiguration.Sections.length > 0;
    }

    function isDbahnConditionVisible() {
        function journeyHasDbahn(journey) {
            return _.any(journey.Legs, (leg) => leg.Carrier === 'Deutsche Bahn');
        }

        function euRailHasDbahn(euRail) {
            return journeyHasDbahn(euRail.OutwardJourney) || (euRail.ReturnJourney && journeyHasDbahn(euRail.ReturnJourney));
        }

        return _.any(tripDetails.EuRails, euRailHasDbahn);
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/trip/controllers/checkout/trip-checkout-terms-controller.js